<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import CreateSubpckageModel from "./create-subpackage";
import DeleteSubpackageModel from "./delete-subpackage";
import EditSubpackageModel from "./edit-subpackage";
import { getSubPackages } from "../../../api/services/sub-package.service";

/**
 * Manage Subpackage Page
 */
export default {
  page: {
    title: "Erlebnisse Verwalten",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    "create-subpackage-model": CreateSubpckageModel,
    "delete-subpackage-model": DeleteSubpackageModel,
    "edit-subpackage-model": EditSubpackageModel,
  },
  data() {
    return {
      title: this.$i18n.t("subpackages.header.title"),
      items: [
        {
          text: this.$i18n.t("subpackages.header.item"),
          active: true,
        },
      ],
      showEditSubpackageModel: false,
      showDeleteSubpackageModel: false,
      showCreateSubpcakageModel: false,
      subpackages: null,
      subpackageToDelete: null,
      subpackageToEdit: null,
    };
  },
  async mounted() {
    await this.getAllSubpackages();
  },
  methods: {
    clickCreateNewSubpackage() {
      this.showCreateSubpcakageModel = true;
    },
    realodPage() {
      window.location.reload();
    },
    async getAllSubpackages() {
      let getAllSubpackages = await getSubPackages();
      if (getAllSubpackages.length > 0) {
        this.subpackages = getAllSubpackages;
      }
    },
    clickDeleteSubpackage(subpackageId) {
      this.subpackageToDelete = subpackageId;
      this.showDeleteSubpackageModel = true;
    },
    clickEditSubpackage(subpackageId) {
      this.subpackageToEdit = subpackageId;
      this.showEditSubpackageModel = true;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <!-- Create Subpackage card -->
      <div class="col-md-6 col-lg-4 col-xl-4 mb-4">
        <div
          class="p-3 text-center"
          style="
            border-radius: 4px;
            border: 2px dashed #a5a5a5;
            color: #a5a5a5;
            background: #fff;
            cursor: pointer;
            height: 400px;
          "
          @click="clickCreateNewSubpackage()"
        >
          <div class="row">
            <div class="col-md-12 mt-5">
              <b-img
                class="mb-3"
                alt=""
                :src="require('@/assets/images/Create Subpackage.png')"
                style="height: 200px"
              ></b-img>
            </div>
            <div class="col-md-12">
              <h6>
                <i class="bx bx-plus-medical bx-tada mr-2"></i>
                {{ $t("subpackages.createSubpackageButton") }}
              </h6>
            </div>
          </div>
        </div>
      </div>
      <!-- Simple Subpackage Card -->
      <div
        class="col-md-6 col-lg-4 col-xl-4 mb-4"
        v-for="(subpackage, subpackageIndex) in subpackages"
        :key="subpackageIndex"
      >
        <b-card style="height: 420px" no-body class="overflow-hidden">
          <b-row>
            <b-col md="12">
              <b-card-img
                v-if="subpackage.titleImage"
                :src="subpackage.titleImage"
                alt="Image"
                class="rounded-0"
                style="height: 220px"
              ></b-card-img>
              <b-card-img
                v-else
                src="https://s3.eu-central-1.amazonaws.com/ms-sissi.uploads/images/ms-sissi-Default-Subpackage.jpg"
                alt="Image"
                class="rounded-0"
                style="height: 220px"
              ></b-card-img>
            </b-col>
            <b-col md="12" class="p-4">
              <b-card-title>
                <h5 class="card-title text-limted-one-lines">
                  {{ subpackage.title }}
                </h5>
              </b-card-title>
              <b-card-text class="text-limted-three-lines">
                <div class="mt-2">
                  <b-badge class="mr-1 font-size-12" variant="primary">
                    {{ subpackage.package.title }}
                  </b-badge>
                </div>
                <div class="mt-3 mb-3">{{ subpackage.description }}</div>
              </b-card-text>
              <b-button
                variant="warning"
                @click="clickEditSubpackage(subpackage.id)"
              >
                <i class="bx bxs-pencil mr-1"></i>
                {{ $t("general.buttons.edit") }}
              </b-button>
              <b-button
                class="ml-2"
                variant="danger"
                @click="clickDeleteSubpackage(subpackage.id)"
              >
                <i class="bx bx-trash-alt mr-1"></i>
                {{ $t("general.buttons.delete") }}</b-button
              >
            </b-col>
          </b-row>
        </b-card>
      </div>
    </div>
    <!-- end row -->

    <!-- Create Subpackage Model -->
    <create-subpackage-model
      v-if="showCreateSubpcakageModel === true"
      :visible="showCreateSubpcakageModel"
      @close="showCreateSubpcakageModel = false"
      @reload="realodPage()"
    />

    <!-- Delete Subpackage Model -->
    <delete-subpackage-model
      v-if="showDeleteSubpackageModel === true"
      :visible="showDeleteSubpackageModel"
      @close="showDeleteSubpackageModel = false"
      @reload="realodPage()"
      :subpackageID="subpackageToDelete"
    />

    <!-- Edit Subpackage Model -->
    <edit-subpackage-model
      v-if="showEditSubpackageModel === true"
      :visible="showEditSubpackageModel"
      @close="showEditSubpackageModel = false"
      @reload="realodPage()"
      :subpackageID="subpackageToEdit"
    />
  </Layout>
</template>

<style scoped>
.text-limted-one-lines {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  -webkit-box-orient: vertical;
}
.text-limted-three-lines {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* number of lines to show */
  -webkit-box-orient: vertical;
}
</style>
